module.exports = __webpack_public_path__ + "img/lemomentcapturer.edeb7d7b.jpg";